// Safe localStorage that won't throw in Safari private mode or when blocked
// Falls back to in-memory storage that lasts for the session
const memFallback = new Map()

export const safeStorage = {
  get(key) {
    try { return localStorage.getItem(key) }
    catch { return memFallback.get(key) || null }
  },
  set(key, value) {
    try { localStorage.setItem(key, value) }
    catch { memFallback.set(key, String(value)) }
  },
  remove(key) {
    try { localStorage.removeItem(key) }
    catch { memFallback.delete(key) }
  },
}
